import React from "react";
// import {Divider} from "../../components/Divider"
export const Screening = () => {
    return (
        <section id="screening" className="bgCream">
            <div className="container pb-5 pt-4 textBlue">
                <h1 className="textBlue text-center fs-1 mb-4"> Screening Depressione Post Partum</h1>

                <p>
                    L’arrivo di un figlio coinvolge il corpo e la mente di una madre per diversi mesi a partire dalla
                    gravidanza.
                </p>
                <p>
                    La sopravvivenza stessa della gravidanza è dovuta in parte ad un equilibrio ormonale specifico della
                    gravidanza che viene a cessare al momento del parto, quando non è più necessario. Questo crollo
                    ormonale produce nel corpo uno squilibrio che insieme ai cambiamenti dati dall’arrivo di un figlio e
                    alle preoccupazioni dovute allo stesso provoca in una buona percentuale di donne il cosiddetto Baby
                    Blues, ovvero una condizione totalmente FISIOLOGICA che inizia a partire dalle primissime settimane
                    dopo il partoe termina intorno alla sesta settimana dopo il parto. I sintomi riconducibili al baby
                    blues sono:
                </p>
                <ul>
                    <li>Umore Instabile</li>
                    <li>Ansia e nervosismo</li>
                    <li>Tristazza non giustificata</li>
                    <li>Irritabilità</li>
                    <li>Pianto improvviso e immotivato</li>
                    <li>Difficoltà di concentrazione</li>
                    <li>Disturbi del sonno</li>
                </ul>

                <p>
                    Queste sensazioni, nonostante appartengano completamente alla fisiologia, non vanno trascurate o
                    relegate ad una fase a cui semplicemente “sopravvivere”, vanno invece riconosciute ed affrontate.{" "}
                </p>

                <h4>In quale modo?</h4>

                <p>
                    Confrontati con qualcuno che senti vicino a te Chiedi aiuto per poterti rilassare e concedere del
                    tempo per te Accogli le sensazioni che ti arrivano, sia quelle positive che quelle negative Non sei
                    “sbagliata”, sei una fase delicata, stai dando il meglio per il tuo bimbo/a ed è assolutamente
                    naturale e comprensibile sentirsi sopraffatte e stanche Nel momento in cui queste sensazioni sopra
                    descritte eccedano la fisiologia o si prolunghino in un periodo di tempo maggiore delle 4/6
                    settimane va presa in considerazione la possibilità che si stia sviluppando un vero e proprio
                    disturbo chiamato Depressione Post Partum che richiede un supporto professionale e competente dalle
                    figure preposte a questo.
                </p>

                <h4>Cosa fare?</h4>

                <p>
                    <strong>NEL CASO TU SIA UN FAMILIARE O UN AMICO </strong>di una donna che presenta i sintomi sopra
                    citati ricordati che davanti a te hai una persona che sta attraversando un periodo di difficoltà che
                    può tranquillamente essere superato ma che necessita di un aiuto di tipo medico e psicologico. Nel
                    caso si trattasse di Depressione Post Partum non si risolverà da sola e non servirà chiedere alla
                    persona di distrarsi, di pensare alle “cose belle”; non sarà utile quindi sminuire le sensazioni e
                    cercare di spostare l’attenzione su ciò che di positivo è presente all’interno della vita di una
                    persona; questo servirà invece a peggiorare la condizione della mamma che si serenità svalutata e
                    che si farà, probabilmente, prendere dai sensi di colpa per non riuscire a valorizzare ciò che di
                    positivo la circonda.
                </p>

                <p>
                    <strong>EL CASO TU SIA UNA MAMMA</strong>
                    che sta sperimentando queste sensazioni ricordati che i tuoi vissuti sono reali e meritevoli di
                    supporto e attenzione. Puoi contattare me (in quanto tecnico di riabilitazione psichiatrica), un
                    consultorio, il tuo medico di base, uno psicologo o uno psichiatra. Tutte queste figure sanno cosa
                    fare e come indirizzarti al meglio per affrontare subito questa condizione che è PASSEGGERA.
                </p>

                <h5>
                    Se stai affrontando un post parto pesante, se provi anche solo alcune di queste sensazioni,
                    contattami{" "}
                    <a className="fs-5 textBlue underline-none" href="/contatti">
                        qui
                    </a>
                </h5>

                <p>
                    Uno strumento utile che ti permetterà di porre l’attenzione sulla tua condizione attuale e sulle tue
                    sensazioni è la scala di Edimburgo che trovi qui sotto in download.
                </p>

                <p>
                    La scala di Edimburgo si pone l’obiettivo di individuare i segni di una depressione post partum; è
                    uno screening di autovalutazione, ma nel caso volessi confrontarti con me riguardo i risultati non
                    esitare a contattarmi!
                </p>
            </div>
        </section>
    );
};
